import { useEffect, useState } from 'react';
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from '../authMedia';
import Headline5 from '../../../compopnents/headings/Headline5';
import { Auth } from "aws-amplify";
import { ForgotPasswordForm } from './forgotform';
import NotificationAlert from '../../../compopnents/notification';
import { getUserDetails } from './services'
import { viewedpageMixpanel } from '../../../utils/mixpanel';

Auth.configure({
  userPoolId: "ap-south-1_RFCGvpA7m",
  userPoolWebClientId: "3mbs8c16e6jc3g0l7iq56obak0", // app client id
  //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "https://ellow-prod-customer.auth.ap-south-1.amazoncognito.com",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://mytalent-ellow.io/dashboard",
    redirectSignOut: "https://mytalent-ellow.io/customerlogin",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
});


function ForgotPassword() {

  const [error, setError] = useState<string>('')
  const [alert, setAlert] = useState<boolean>(false)

  useEffect(() => {
    
    viewedpageMixpanel();
  
  },[]);

  const submitValues = (data: any) => {
    setError(' ')
    getUserDetails(data.email).then((response) => {  
      if(response && response.status === 2){
        Auth.forgotPassword(data.email)
          .then(result => {
          setAlert(true)
          setTimeout(() => {
          setAlert(false)
          }, 3000)
        })
        .catch(err => {
          setError(err.message)
        })
      }
      else{
        setError('This Email address is not registered with us')
      }
    })
    .catch((err: any) => {
    }
  )}

  const alertOnclose = () => {
    setAlert(false)
  }

  return (
    <section className="App">
      {alert && <NotificationAlert closable={true} onClose={alertOnclose}>A mail has been sent to your registered mail address, please find the link attached with the mail to update your password.</NotificationAlert> }
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
          <aside className={Styles.loginSignupWapper}>   
            <Headline5>Forgot Your Password ?</Headline5>
            <div className={Styles.loginWith}>
                  <ForgotPasswordForm  ClickHandler={submitValues} />
              {error ?
                <div><p className="error-message">{error}</p></div>
                :
                <div></div>
              } 
              {/* <div className={Styles.alreadyRegistered}>Don’t have an ellow account? <Link to="/signup">Sign up</Link></div>     */}
            </div> 
          </aside>
          </div>
        </div>
        <AuthMedia/>
      </div>
    </section>
  )
}

export default ForgotPassword;
